import { createAxiosInstance } from "./index";
import hostConfig from "@/config/hostResolver";

const baseUrl = process.env.VUE_APP_WALLET_V3_URL ?? `${hostConfig.apiBaseUrl}/wallet-service-ts`;

class WalletService {
  constructor() {
    this.apiClient = createAxiosInstance(baseUrl);
  }

  async getWalletProfile(userId = null, params = {}) {
    return (
      await this.apiClient?.get(`/v3/wallet/profile${userId ? `/${userId}` : ""}`, {
        params,
        errorContext: "Failed to get wallet transactions",
      })
    )?.data;
  } //getWalletProfile

  async sendPaymentBulk(data) {
    return (
      await this.apiClient?.post(
        `/v3/parent-payment-rule/bulk`,
        {
          budgetId: Number(data.users[0]?.budgetId),
          clientId: Number(data.users[0]?.clientId),
          recipients: data.users.map((u) => ({
            userId: u.userId,
            amount: Number(u.amount),
            programId: u.programId ? Number(u.programId) : null,
            ruleGroupId: u.ruleGroupId ? Number(u.ruleGroupId) : null,
          })),
          description: data.description,
          transactionType: data.transactionType || "DEFAULT",
          classification: data.classification,
          sourceUserId: data.sourceUserId,
        },
        {
          timeout: 0, // No timeout — bulk payments can take minutes to process (matches v1 pattern)
          retryRequest: false, // Don't retry — the payment may have been created
          errorContext: "Failed to send bulk payment",
        }
      )
    )?.data;
  } //sendPaymentBulk
}

export default WalletService;
